import { IConfig } from '@cian/config/shared';
import { TDeviceType } from '@cian/ui-kit';

import {
  NEWBUILDING_DESKTOP_BASE_QUERY_URL_CONFIG_KEY,
  NEWBUILDING_MOBILE_BASE_QUERY_URL_CONFIG_KEY,
} from '../../constants/config';

export function getNewbuildingListingUrl(newbuildingIds: number[], config: IConfig, deviceType: TDeviceType): string {
  const baseQueryUrl =
    deviceType === 'desktop'
      ? config.getStrict<string>(NEWBUILDING_DESKTOP_BASE_QUERY_URL_CONFIG_KEY)
      : config.getStrict<string>(NEWBUILDING_MOBILE_BASE_QUERY_URL_CONFIG_KEY);

  const newobjectParams = newbuildingIds.map((id, index) => `newobject[${index}]=${id}`).join('&');

  return `${baseQueryUrl}&${newobjectParams}`;
}
